<template>
  <main>
    <div class="d-flex flex-column align-items-center justify-content-center">
      <section class="">
        <div class="main-div-company">
          <div class="div-logo">
            &nbsp;
          </div>
          <h1>FC ROBI</h1>
        </div>
      </section>
      <form @submit.prevent="onSubmit" class="mt-3">
<!--        <p>message : {{getMessageAdminConnexion}}</p>-->
        <div class="form-group">
          <label for="admin_nom_utilisateur">Nom d'utilisateur</label>
          <input type="text"
                 v-model="dataForm.nom_utilisateur"
                 placeholder="Saisissez votre nom d'utilisateur"
                 class="form-control"
                 id="admin_nom_utilisateur"
                 name="admin_nom_utilisateur">
        </div>
        <div class="form-group">
          <label for="admin_mot_de_passe">Mot de passe</label>
          <input type="password"
                 v-model="dataForm.mot_de_passe"
                 placeholder="Saisissez votre mot de passe"
                 class="form-control"
                 id="admin_mot_de_passe"
                 name="admin_mot_de_passe">
        </div>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="exampleCheck1">
          <label class="form-check-label" for="exampleCheck1">M'authentifier</label>
        </div>
        <button type="submit" class="btn btn-block">SE CONNECTER</button>
        <p class="mt-5">Contacter le support client si vous ne pouvez vous connecter</p>
      </form>
    </div>
  </main>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Login",
  props: {},
  data(){
    return{
      admin: null,
      dataForm: {
        admin_id: '',
        nom_utilisateur: '',
        mot_de_passe: '',
        table: 'admin'
      }
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosAdminAuthentication',
    ]),
    onSubmit(){
      this.axiosAdminAuthentication(this.dataForm)
          .then((data) => {
            if(this.getAdmin)
              this.$router.push({ path: '/' })
            // console.log("login then "+data)
          })
          .catch((data) => {
            // console.log("login catch "+data)
          })
    }
  },
  computed: {
    ...mapGetters([
        'getMessageAdminConnexion',
    ])
  },
  beforeRouteEnter(to, from, next) {
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
main{
  min-height: 90vh;
  background-color: #0c5460;
  //background-image: url(http://pos.zoom243.com/assets/img/walpapers/walpaper-9.jpg);
  //background-size: cover;
  //background-position: center;
  //background-repeat: no-repeat;
  & > div{
    min-height: inherit;
    padding: 0 1.5rem;
    background-color: rgba(84, 88, 113, 0.7);
    color: var(--color-white, rgba(255, 255, 255, 1));
    & > section{
      & > div.main-div-company{
        & > div.div-logo{
          margin: 0 auto;
          width: 100px;
          height: 100px;
          background-color: var(--color-white, rgba(255, 255, 255, 1));
          background-image: url(http://pos.zoom243.com/assets/img/logo.png);
          background-size: 80px;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 50%;
        }
        & > h1{
          font-size: x-large;
        }
      }
    }
    & > form{
      & > button{
        background-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
        border-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
      }
      & > button:hover{
        background-color: var(--color-soft-blue, rgba(99, 103, 128, 1));
        color: var(--color-white-light, rgba(255, 255, 255, .5));
      }
    }
  }
}
@media (min-width: 576px) {
  main{
    min-height: 100vh;
    background-color: #0c5460;
    //background-image: url(http://pos.zoom243.com/assets/img/walpapers/walpaper-9.jpg);
    background-image: url(../assets/img/bg-body.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    & > div{
      min-height: inherit;
      padding: 0;
      background-color: rgba(84, 88, 113, 0.7);
      color: var(--color-white, rgba(255, 255, 255, 1));
      & > section{
        & > div.main-div-company{
          & > div.div-logo{
            margin: 0 auto;
            width: 100px;
            height: 100px;
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            background-image: url(../assets/img/logo-1.png);
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 50%;
          }
          & > h1{
            font-size: x-large;
          }
        }
      }
      & > form{
        & > button{
          background-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
          border-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
        }
        & > button:hover{
          background-color: var(--color-soft-blue, rgba(99, 103, 128, 1));
          color: var(--color-white-light, rgba(255, 255, 255, .5));
        }
      }
    }
  }
}

@media (min-width: 768px) {
  main{
    & > div{
      min-height: inherit;
      padding: 0;
      background-color: rgba(84, 88, 113, 0.7);
      color: var(--color-white, rgba(255, 255, 255, 1));
      & > section{
        & > div.main-div-company{
          & > div.div-logo{
          }
          & > h1{
            font-size: x-large;
          }
        }
      }
      & > form{
        & > button{
          background-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
          border-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
        }
        & > button:hover{
          background-color: var(--color-soft-blue, rgba(99, 103, 128, 1));
          color: var(--color-white-light, rgba(255, 255, 255, .5));
        }
      }
    }
  }
}

@media (min-width: 992px) {
  main{
    & > div{
      min-height: inherit;
      padding: 0;
      background-color: rgba(84, 88, 113, 0.7);
      color: var(--color-white, rgba(255, 255, 255, 1));
      & > section{
        & > div.main-div-company{
          & > div.div-logo{
          }
          & > h1{
            font-size: x-large;
          }
        }
      }
      & > form{
        & > button{
          background-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
          border-color: var(--color-atomic-steel-blue, rgba(84, 88, 113, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
        }
        & > button:hover{
          background-color: var(--color-soft-blue, rgba(99, 103, 128, 1));
          color: var(--color-white-light, rgba(255, 255, 255, .5));
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue